import { useState, useEffect } from 'react'
import { Grid, Radio } from '@mui/material'

import Dialog from './Dialog'
import Select from './Select'
import InputField from './InputField'
import AutoComplete from './AutoComplete'
import { sortNumerically, sortGironi } from '../hooks/sort-functions'
import { getGironi } from '../hooks/selection-get-functions'
import { groupByGirone, rangeFun } from '../hooks/utils-functions'
import { GIRONI_FUNCTIONS } from '../settings/settings'

const DialogGirone = ({
  open,
  handleClose,
  triggerFunction,
  team,
  iscrizioniGironi,
}) => {
  const [newTeam, setNewTeam] = useState()
  const [newGirone, setNewGirone] = useState()
  const [newPosizione, setNewPosizione] = useState()
  const [newGironeAdd, setNewGironeAdd] = useState()
  const [newPosizioneAdd, setNewPosizioneAdd] = useState()
  const [selectedFunction, setSelectedFunction] = useState()

  const resetGironi = () => {
    setNewTeam()
    setNewGirone()
    setNewPosizione()
    setNewGironeAdd()
    setNewPosizioneAdd()
  }

  const iscrizioniCategoria = iscrizioniGironi?.filter(
    i => i.categoria === team?.categoria,
  )

  const iscrizioniGirone = iscrizioniCategoria?.filter(
    i => i.girone === newGirone,
  )

  // error functions
  const errorNewGirone = x =>
    x &&
    (iscrizioniCategoria.map(t => t.girone).includes(x) ||
      !/^[a-zA-Z0-9-_]+$/.test(x))

  if (!selectedFunction) setSelectedFunction(GIRONI_FUNCTIONS[0])

  useEffect(() => {
    resetGironi()
  }, [open])

  return (
    <Dialog
      open={open}
      handleClose={handleClose}
      triggerFunction={() =>
        triggerFunction(
          team,
          selectedFunction,
          newGirone,
          newPosizione,
          newTeam,
          newGironeAdd,
          newPosizioneAdd,
        )
      }
      title='Cambio girone'
      textUndo='Annulla'
      textConfirm='Salva'
      maxWidth='md'
    >
      <Grid container spacing={3} sx={{ width: '100%' }}>
        <Grid container alignItems='center' sx={{ width: '100%' }}>
          <Grid size={{ xs: 12, md: 6 }}>
            <center>
              <b>{team?.nomeSquadra}</b>
            </center>
          </Grid>
          <Grid size='grow'>
            <center>
              Girone <b>{team?.girone}</b>
            </center>
          </Grid>
          <Grid size='grow'>
            <center>
              Posizione <b>{team?.posizione}</b>
            </center>
          </Grid>
        </Grid>
        <Grid container alignItems='center' sx={{ width: '100%' }}>
          <Grid size={{ xs: 2, md: 1 }}>
            <center>
              <Radio
                id='girone-posizione'
                value={GIRONI_FUNCTIONS[0]}
                checked={selectedFunction === GIRONI_FUNCTIONS[0]}
                onChange={event => {
                  setSelectedFunction(event.target.value)
                }}
              />
            </center>
          </Grid>
          <Grid size={{ xs: 10, md: 5 }}>Scegli girone e posizione...</Grid>
          <Grid size={{ xs: 12, md: 3 }}>
            <center>
              <Select
                id='girone'
                value={iscrizioniCategoria?.length && newGirone}
                options={getGironi(iscrizioniCategoria)}
                label='Girone'
                onChange={value => {
                  setNewGirone(value)
                  setNewPosizione()
                }}
                disabled={selectedFunction !== GIRONI_FUNCTIONS[0]}
              />
            </center>
          </Grid>
          <Grid size={{ xs: 12, md: 3 }}>
            <center>
              <Select
                id='posizione'
                value={iscrizioniGirone?.length && newPosizione}
                options={
                  iscrizioniGirone?.length
                    ? rangeFun(
                        Math.max(...iscrizioniGirone?.map(t => t.posizione)) +
                          1,
                      )
                    : undefined
                }
                label='Posizione'
                onChange={setNewPosizione}
                disabled={selectedFunction !== GIRONI_FUNCTIONS[0]}
              />
            </center>
          </Grid>
        </Grid>
        <Grid container alignItems='center' sx={{ width: '100%' }}>
          <Grid size={{ xs: 2, md: 1 }}>
            <center>
              <Radio
                id='scambia'
                value={GIRONI_FUNCTIONS[1]}
                checked={selectedFunction === GIRONI_FUNCTIONS[1]}
                onChange={event => setSelectedFunction(event.target.value)}
              />
            </center>
          </Grid>
          <Grid size={{ xs: 10, md: 5 }}>Scambia con squadra...</Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <center>
              <AutoComplete
                id='squadra'
                disabled={selectedFunction !== GIRONI_FUNCTIONS[1]}
                value={newTeam}
                label='Squadra'
                options={iscrizioniCategoria?.sort(
                  (a, b) =>
                    sortGironi(a.girone, b.girone) ||
                    sortNumerically(a.posizione, b.posizione),
                )}
                groupBy={groupByGirone}
                getOptionLabel={op => op.nomeSquadra}
                onChange={value => setNewTeam(value || undefined)}
              />
            </center>
          </Grid>
        </Grid>
        <Grid container alignItems='center' sx={{ width: '100%' }}>
          <Grid size={{ xs: 2, md: 1 }}>
            <center>
              <Radio
                id='nuovo-girone'
                value={GIRONI_FUNCTIONS[2]}
                checked={selectedFunction === GIRONI_FUNCTIONS[2]}
                onChange={event => setSelectedFunction(event.target.value)}
              />
            </center>
          </Grid>
          <Grid size={{ xs: 10, md: 5 }}>Metti in un nuovo girone...</Grid>
          <Grid size={{ xs: 12, md: 3 }}>
            <center>
              <InputField
                id='girone-add'
                disabled={selectedFunction !== GIRONI_FUNCTIONS[2]}
                value={newGironeAdd}
                label='Nuovo girone'
                onChange={setNewGironeAdd}
                errorText='Non valido: esiste già o ha caratteri non ammessi!'
                errorFunc={errorNewGirone}
              />
            </center>
          </Grid>
          <Grid size={{ xs: 12, md: 3 }}>
            <center>
              <Select
                id='posizione-add'
                value={newPosizioneAdd}
                options={[1, 2, 3, 4, 5, 6]}
                label='Posizione'
                onChange={setNewPosizioneAdd}
                disabled={selectedFunction !== GIRONI_FUNCTIONS[2]}
              />
            </center>
          </Grid>
        </Grid>
        <Grid container alignItems='center' sx={{ width: '100%' }}>
          <Grid size={{ xs: 2, md: 1 }}>
            <center>
              <Radio
                id='togli'
                value={GIRONI_FUNCTIONS[3]}
                checked={selectedFunction === GIRONI_FUNCTIONS[3]}
                onChange={event => setSelectedFunction(event.target.value)}
              />
            </center>
          </Grid>
          <Grid size={{ xs: 10, md: 5 }}>Togli dai gironi.</Grid>
        </Grid>
      </Grid>
    </Dialog>
  )
}

export default DialogGirone
